export enum EmphasisSliderSectionVariants {
  EXTERNAL = "external-text",
  INTERNAL = "internal-text",
  INTERNAL_LIGHT = "internal-light",
}
